import { createContext, useContext, useState, useEffect } from "react";

const STORAGE_KEY = "pe_simulation_v1";

const defaultInput = {
  kota: "",
  tipe_bangunan: "rumah",
  daya_pln_va: 3500,
  daya_pln_lain: null,
  fase: "1-phase",
  kwh_bulanan: null,
  tagihan_rp: null,
  tarif_per_kwh: 1445,
  hari_periode: 30,
  siang_pct: 35,
  malam_pct: 65,
  peralatan_besar: [],
  prioritas: "seimbang",
  beban_backup_kw: 1.0,
  durasi_backup_jam: 4,
  reserve_pct: 20,
  anggaran_rp: null,
  luas_atap_m2: null,
  jenis_atap: "beton",
  arah_atap: "utara",
  bayangan: "minimal",
};

const SimulationCtx = createContext(null);

export function SimulationProvider({ children }) {
  const [input, setInput] = useState(defaultInput);
  const [result, setResult] = useState(null);
  const [selectedTier, setSelectedTier] = useState(null);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed.input) setInput({ ...defaultInput, ...parsed.input });
        if (parsed.result) setResult(parsed.result);
        if (parsed.selectedTier) setSelectedTier(parsed.selectedTier);
      }
    } catch {}
  }, []);

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ input, result, selectedTier }));
    } catch {}
  }, [input, result, selectedTier]);

  const updateInput = (patch) => setInput((p) => ({ ...p, ...patch }));
  const reset = () => { setInput(defaultInput); setResult(null); setSelectedTier(null); };

  return (
    <SimulationCtx.Provider value={{ input, updateInput, result, setResult, selectedTier, setSelectedTier, reset }}>
      {children}
    </SimulationCtx.Provider>
  );
}

export function useSimulation() {
  const ctx = useContext(SimulationCtx);
  if (!ctx) throw new Error("useSimulation must be used within SimulationProvider");
  return ctx;
}
